// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na {\n  text-decoration: none;\n}\n.byline {\n  position: absolute;\n  top: 20px;\n  left: 70px;\n  font-style: italic;\n}\n.v-bottom-navigation {\n  position: fixed;\n  bottom: 20px;\n}\n.blue-text {\n  color: #007dba !important;\n}\n.yellow-text {\n  color: #ffcc00 !important;\n}\n.short-menu {\n  margin-left: 140px;\n  border-left: 3px solid #ffcc00;\n}\n", ""]);
// Exports
module.exports = exports;
